import { render, staticRenderFns } from "./list.vue?vue&type=template&id=8a3a17dc&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=8a3a17dc&prod&lang=less&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=8a3a17dc&prod&lang=less&"
import style2 from "./list.vue?vue&type=style&index=2&id=8a3a17dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3a17dc",
  null
  
)

export default component.exports